import { Link, Text, HStack, Badge } from "@chakra-ui/react";

interface FooterLinkProps {
  label: string;
  path: string;
  badge?: {
    text: string;
    colorScheme: string;
  };
  fontSize?: string;
  fontWeight?: string;
}

const FooterLink: React.FC<FooterLinkProps> = ({ label, path, badge, fontSize = "sm", fontWeight = "medium" }) => {
  return (
    <Link
      color="gray.500"
      fontSize={fontSize}
      fontWeight={fontWeight}
      _hover={{ color: "teal.500" }}
      onClick={(e) => {
        e.preventDefault();
        window.history.pushState({}, "", path);
        window.dispatchEvent(new PopStateEvent("popstate"));
      }}
    >
      {badge ? (
        <HStack>
          <Text>{label}</Text>
          <Badge colorScheme={badge.colorScheme} size="sm">
            {badge.text}
          </Badge>
        </HStack>
      ) : (
        label
      )}
    </Link>
  );
};

export default FooterLink;
